import cloneDeep from 'lodash/cloneDeep';
import { merge } from '@streamr/utils';
import { generateClientId } from './utils/utils';
import validate from './generated/validateConfig';
import { config as CHAIN_CONFIG } from '@streamr/config';
import { CONFIG_TEST } from './ConfigTest';
import { DEFAULT_ENVIRONMENT_ID, } from './ConfigTypes';
export const createStrictConfig = (input = {}) => {
    // TODO is it good to cloneDeep the input object as it may have object references (e.g. auth.ethereum)?
    let config = cloneDeep(input);
    const environment = config.environment ?? DEFAULT_ENVIRONMENT_ID;
    config = applyEnvironmentDefaults(environment, config);
    const strictConfig = validateConfig(config);
    strictConfig.id ??= generateClientId();
    return strictConfig;
};
const applyEnvironmentDefaults = (environmentId, data) => {
    const defaults = CHAIN_CONFIG[environmentId];
    let config = merge({
        environment: environmentId,
        network: {
            controlLayer: {
                entryPoints: defaults.entryPoints
            }
        },
        contracts: {
            ethereumNetwork: {
                chainId: defaults.id
            },
            streamRegistryChainAddress: defaults.contracts.StreamRegistry,
            streamStorageRegistryChainAddress: defaults.contracts.StreamStorageRegistry,
            storageNodeRegistryChainAddress: defaults.contracts.StorageNodeRegistry,
            sponsorshipFactoryChainAddress: defaults.contracts.SponsorshipFactory,
            rpcs: defaults.rpcEndpoints,
            theGraphUrl: defaults.theGraphUrl
        }
    }, data);
    if (environmentId === 'polygon') {
        config.contracts.ethereumNetwork = {
            highGasPriceStrategy: true,
            ...config.contracts.ethereumNetwork
        };
    }
    else if (environmentId === 'dev2') {
        config = merge(CONFIG_TEST, config);
    }
    return config;
};
export const validateConfig = (data) => {
    if (!validate(data)) {
        throw new Error(validate.errors.map((e) => {
            let text = e.instancePath + ' ' + e.message;
            if (e.params.additionalProperty) {
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                text += `: ${e.params.additionalProperty}`;
            }
            return text;
        }).join('\n'));
    }
    return data;
};
export const redactConfig = (config) => {
    if (config.auth?.privateKey !== undefined) {
        config.auth.privateKey = '(redacted)';
    }
};
//# sourceMappingURL=Config.js.map